var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bWJ2BykKl9cq4x2rxzGKI"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@nyati-mexico-sa-de-cv"]={id:"bWJ2BykKl9cq4x2rxzGKI"};
      